<script setup lang="ts">
import { UIContentWrap, UISpin } from '@gohighlevel/ghl-ui'
import Postmate from 'postmate'

import { computed, onMounted, provide, ref } from 'vue'
import { useRoute } from 'vue-router'
import { setLocale as setLocalLazy } from '@gohighlevel/ghl-proposals-common/src/locales'
import { useAppStore } from '@/store/app'

// Mobile data storage
interface MobileData {
  mobileToken?: string
}

declare global {
  interface Window {
    setData?: (data: MobileData) => void
    getMobileData?: () => MobileData
  }
}

const appStore = useAppStore()
const isPreview = computed(() => route.name === 'proposals-estimates-preview')
const route = useRoute()
provide('route', route)

const mobileData = ref<MobileData>({})
const isMobileDataSet = ref(false)

// Check if current route is mobile preview
const isMobilePreviewRoute = computed(
  () => route.name === 'document-mobile-preview'
)

// Show loader if mobile preview route and data not set yet
const showMobileLoader = computed(
  () => isMobilePreviewRoute.value && !isMobileDataSet.value
)

const handshake = new Postmate.Model({
  'updated-token': (token: string) => appStore.refreshToken(token),
})
window.getToken = function () {
  return appStore.tokenId
}
window.getPostmateHandshake = function () {
  return appStore.handshake
}
// Expose setData for mobile team to set mobile data
window.setData = function (data: MobileData) {
  mobileData.value = data
  isMobileDataSet.value = true
}
// Expose getter for mobile data
window.getMobileData = function () {
  return mobileData.value
}

handshake.then(async ({ model }: any) => {
  appStore.setupApp({ ...model, handshake })
})

// Function to set locales
const setLocales = (lang: string) => {
  const locale = lang.replace('_', '-')
  localStorage.setItem('locales', locale)
  setLocalLazy(locale)
}

const getUrlParameter = (name: string): string | null => {
  if (typeof window === 'undefined' || !window.location.search) {
    return null
  }
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}

// Get the locale from the URL parameters
onMounted(() => {
  const locale = getUrlParameter('locale') || 'en-US' // Default to 'en-US' if not provided
  setLocales(locale)
})
</script>

<template>
  <UIContentWrap full-screen>
    <!-- Show loader for mobile preview until setData is called -->
    <div
      v-if="showMobileLoader"
      class="flex flex-col items-center justify-center h-screen w-screen"
    >
      <UISpin />
    </div>
    <!-- Show router view: for mobile preview only when data is set, for other routes use existing logic -->
    <router-view
      v-else-if="
        isMobilePreviewRoute ? isMobileDataSet : !isPreview || appStore.tokenId
      "
    />
  </UIContentWrap>
</template>

<style lang="scss">
@keyframes point {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(-10px);
  }
  60% {
    transform: translateX(-5px);
  }
}

.point-el {
  //  border-width: 1px !important;
  //  box-sizing: content-box !important;
  //  border-radius: 0.125em;
  //  transition: all ease;
  //  border-style: solid !important;
  //  border-color: red !important;
  // box-shadow: 1px 1px 0px 2px red;
  &.filled {
    // box-shadow: 0px 0px 0px 2px red !important;
  }
  &:after {
    position: absolute;
    width: 100%;
    content: '';
    top: 0px;
    left: 0px;
    height: 100%;
    outline: 2px solid #fec84b;
    border-radius: 1px;
    outline-offset: 2px;
    z-index: -1;
  }
  //   &.signature-el,
  //   &.date-field-el {
  //     &::after {
  //       top: 1px;
  //       left: 1px;
  //     }
  //  }
}
</style>